var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.ColumnContent,
    { staticClass: "px-2", attrs: { title: _setup.context.service.name } },
    _vm._l(_setup.towns, function (town) {
      return _c(
        "a",
        {
          key: town.name,
          staticClass:
            "service-town d-flex text--text text-decoration-none mb-4 text-body-1",
          attrs: { "data-qa": "service_town", href: town.href },
        },
        [
          _c(
            "div",
            {
              staticClass: "mr-auto",
              attrs: { "data-qa": "service_town_name" },
            },
            [_vm._v("\n      " + _vm._s(town.name) + "\n    ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "primary--text ml-2" }, [
            _vm._v("\n      от\n      "),
            _c("span", { attrs: { "data-qa": "service_town_price" } }, [
              _vm._v(_vm._s(town.price)),
            ]),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }